import { render } from "./LoginModal.vue?vue&type=template&id=08e3c280&scoped=true"
import script from "./LoginModal.vue?vue&type=script&lang=ts"
export * from "./LoginModal.vue?vue&type=script&lang=ts"

import "./LoginModal.vue?vue&type=style&index=0&id=08e3c280&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-08e3c280"

export default script